import { render, staticRenderFns } from "./revenue-sharing-ratio-set.vue?vue&type=template&id=e4c12da0&scoped=true&"
import script from "./revenue-sharing-ratio-set.vue?vue&type=script&lang=js&"
export * from "./revenue-sharing-ratio-set.vue?vue&type=script&lang=js&"
import style0 from "./revenue-sharing-ratio-set.vue?vue&type=style&index=0&id=e4c12da0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4c12da0",
  null
  
)

export default component.exports